const clipText = (text, length, suffix= '...') => {
    if(!text) return ''
    if(text.length > length)
        return text.substring(0, length).concat(suffix)
    return text
}

export default clipText